import React, { useEffect, useState } from 'react';
import { Bot, Hand } from 'lucide-react';
import { api } from '@/lib/api';
import { Card } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Loading } from '@/components/OpsUI';

const when = (iso) => (iso ? new Date(iso).toLocaleString('es', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }) : '');

export function ConversationList({ selected, onSelect, tick }) {
  const [items, setItems] = useState(null);
  const [q, setQ] = useState('');

  useEffect(() => {
    const load = () => api.get('/whatsapp/conversations').then(({ data }) => setItems(data)).catch(() => setItems([]));
    load();
    const t = setInterval(load, 6000);
    return () => clearInterval(t);
  }, [tick]);

  const shown = (items || []).filter((c) => `${c.name} ${c.phone} ${c.contact?.church || ''} ${c.contact?.pastor || ''}`.toLowerCase().includes(q.toLowerCase()));

  return (
    <Card className="p-3 flex flex-col gap-2 overflow-hidden" data-testid="whatsapp-conversation-list">
      <Input placeholder="Buscar nombre, iglesia o número" value={q} onChange={(e) => setQ(e.target.value)} data-testid="whatsapp-search" />
      {items === null ? <Loading /> : (
        <div className="overflow-y-auto max-h-[620px] -mx-1">
          {shown.length === 0 && <div className="p-6 text-center text-xs text-[hsl(var(--muted-foreground))]" data-testid="whatsapp-empty">Aún no hay conversaciones.</div>}
          {shown.map((c) => (
            <button key={c.id} type="button" onClick={() => onSelect(c.id)} data-testid={`whatsapp-conv-${c.id}`}
              className={`w-full text-left px-3 py-2.5 rounded-md transition-colors duration-150 ${selected === c.id ? 'bg-[hsl(var(--primary)/.15)]' : 'hover:bg-[hsl(var(--muted)/.5)]'}`}>
              <div className="flex items-center justify-between gap-2">
                <span className="font-medium text-sm truncate">{c.contact?.pastor || c.name || c.phone}</span>
                <span className="text-[10px] text-[hsl(var(--muted-foreground))] shrink-0">{when(c.last_message_at)}</span>
              </div>
              <div className="text-[11px] text-[hsl(var(--muted-foreground))] truncate">{c.contact?.church || c.phone}</div>
              <div className="flex items-center gap-1.5 mt-1">
                <span className="text-xs truncate flex-1 text-[hsl(var(--muted-foreground))]">{c.last_preview}</span>
                {c.pending_draft && <span className="text-[10px] px-1.5 rounded-full bg-amber-500/20 text-amber-300" data-testid={`whatsapp-conv-draft-${c.id}`}>Borrador IA</span>}
                {c.ai_enabled === false ? <Hand className="h-3 w-3 text-sky-300" /> : <Bot className="h-3 w-3 text-emerald-300" />}
                {c.unread > 0 && <span className="text-[10px] min-w-4 px-1 rounded-full bg-emerald-500 text-black text-center" data-testid={`whatsapp-conv-unread-${c.id}`}>{c.unread}</span>}
              </div>
            </button>
          ))}
        </div>
      )}
    </Card>
  );
}
